<script lang="ts" setup>
import type { TripOrderStop } from "@/views/trips/edit/trip";
import { OrderStopStatus, OrderStopStatusMap } from "@/data/order";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    stop: TripOrderStop;
    isBadge?: boolean;
    hideEdgeStatuses?: boolean;
  }>(),
  {
    isBadge: false,
    hideEdgeStatuses: false,
  },
);

const visible = computed(() => {
  return props.hideEdgeStatuses
    ? ![OrderStopStatus.notStarted, OrderStopStatus.completed].includes(props.stop.status)
    : true;
});

const classes = computed(() => {
  if (props.stop.isDeleted) {
    return "text-grey";
  }
  switch (props.stop.status) {
    case OrderStopStatus.inProgress:
    case OrderStopStatus.partiallyCompleted:
      return "bg-amber-lighten-2 text-grey-darken-3";
    case OrderStopStatus.completed:
      return "bg-green-lighten-1 text-white";
    default:
      return "bg-grey-lighten-4 text-grey-darken-3";
  }
});

const label = computed(() => {
  return OrderStopStatusMap.find((s) => s.id === props.stop.status)?.name || "Unknown";
});

const nonStarted = computed(() => {
  return props.stop.status === OrderStopStatus.notStarted;
});
</script>

<template>
  <div v-if="visible">
    <div v-if="nonStarted || isBadge" class="rounded-lg font-size-12 font-weight-500 text-grey-darken-1">
      {{ label }}
    </div>

    <div v-else :class="classes" class="status-label rounded-lg pr-2 pl-2">
      {{ label }}
    </div>
  </div>
</template>

<style scoped>
.status-label {
  white-space: nowrap;
  display: inline-block;
  line-height: 16px !important;
  font-size: 11px;
}
</style>
